import React from 'react';
export default function ResourceMapHeader(props) {
    const { globalConfig } = props;
    return (React.createElement("div", { className: "px-3 py-4" },
        React.createElement("div", { className: "row justify-content-center" },
            React.createElement("div", { className: "col-12" },
                React.createElement("div", { className: "Heading Heading--h3" },
                    React.createElement("h1", { className: "Heading__title" }, globalConfig.pageTitle || '')))),
        globalConfig.pageBlurb &&
            React.createElement("div", { className: "EventPage__blurb" },
                React.createElement("div", { className: "RawHTML", dangerouslySetInnerHTML: { __html: globalConfig.pageBlurb } }))));
}
